module.exports = __webpack_public_path__ + "static/media/plane.164e772a.svg";